var _circle, _path, _path2, _rect, _rect2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function Svg02Paper(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 54,
    height: 54,
    viewBox: "0 0 54 54",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 27,
    cy: 27,
    r: 27,
    fill: "#FFEFEF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19 18H37C37.5523 18 38 18.4477 38 19V32.5833V33H39V32.5833V19C39 17.8954 38.1046 17 37 17H19C17.8954 17 17 17.8954 17 19V37C17 38.1046 17.8954 39 19 39H32.5833H33V38H32.5833H19C18.4477 38 18 37.5523 18 37V19C18 18.4477 18.4477 18 19 18Z",
    fill: "#D91F05"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M33 33V39L36 36L39 33H33Z",
    fill: "#D91F05"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 21,
    y: 23,
    width: 15,
    height: 1,
    rx: 0.5,
    fill: "#D91F05"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 21,
    y: 27,
    width: 7,
    height: 1,
    rx: 0.5,
    fill: "#D91F05"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg02Paper);
export default __webpack_public_path__ + "static/media/02paper.de6503734e3acb71b10134a636706c99.svg";
export { ForwardRef as ReactComponent };